import React, { useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Modal from 'react-bootstrap/Modal';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

import Kba from "../../Components/Elements/Kba";

import { useUser } from "~/Context/userContext";
import CustomPlaylistContainer from "~/Containers/CustomPlaylistContainer";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import JukeboxPlayPlaylistCustom from "./JukeboxPlayPlaylistCustom";
import RecentPlaylists from "~/Components/SideNav/RecentPlaylists";


const PlaylistPage = ({ match }) => {
  const { state: userState } = useUser();
  let history = useHistory();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const playlistId = match.params.playlistId;

  function handleEditClick() {
    history.push(`/playlist/${playlistId}/edit`);
  }
  function handleGoToRecent() {
    history.push(`/playlists/recent`);
  }
  const handleGoToSearch = () => {
    history.push(`/search`);
  };
  function createMarkup(text) {
    return { __html: text };
  }
  return (
    <div className="mb-page-m">
      <CustomPlaylistContainer
        playlistId={playlistId}
        render={({ playlist, loading, failure }) => {
          const isOwner = playlist.userDir === userState.user.dir;
          if (failure) {
            return <Redirect to={"/"} />;
          }
          return (
            <React.Fragment>
              {loading ? (
                <div><SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                  <Skeleton count={10} />
                </SkeletonTheme></div>
              ) : (
                <>
                  <Helmet>
                    <title>{playlist.name} Playlist | Dream Chimney</title>
                    <link rel="canonical" href={`https://www.dreamchimney.com/tracks/playlist/${playlistId}`} />
                  </Helmet>
                  <Row>
                    <Col lg={9} md={8} xs={12}>
                      <h2>
                        <div className="playlistTitle">
                          {" "}
                          <FontAwesomeIcon icon={faMusic} style={{ fontSize: 24, marginRight: 14 }} />
                          {playlist.name}
                        </div>
                        <div className="playlistSubTitle">
                          Playlist by {playlist.user.full_name} {playlist.user.chim_dir ? `Chimney` : ``}
                        </div>
                      </h2>

                    </Col>
                    <Col lg={3} md={4} xs={12}>
                      <div className="">
                        <JukeboxPlayPlaylistCustom className="hide-mobile" playlistId={playlist.id} playlistName={playlist.name} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} xs={12}>
                      {playlist.description && (
                        <div className="playlistDescription">
                          <em><span dangerouslySetInnerHTML={createMarkup(playlist.description)} /></em>
                        </div>
                      )}
                      {isOwner && !playlist.description && (
                        <div className="playlistDescription">
                          <div className="descriptionHelpText" onClick={() => handleEditClick()}>
                            Click here to add a description
                          </div>
                        </div>
                      )}
                      {isOwner && (
                        <div className="playlistEditButtons">



                          {/* <div style={{ marginTop: 20 }}>
                            <Button variant="primary" size="sm" onClick={handleShow}>
                              Add Tracks
                            </Button>
                          </div> */}

                        </div>
                      )}

                      <div className="hide-md-and-below" style={{ marginTop: 40 }}>
                        <RecentPlaylists limit={6} />
                      </div>

                    </Col>
                    <Col lg={9} xs={12}>

                      <div style={{ marginTop: "2px" }}>
                        <div style={{ float: 'right' }}>
                          {isOwner && (<Button variant="primary" size="sm" onClick={() => handleEditClick()}>
                            Edit Playlist
                          </Button>)}
                        </div>
                        <h3>
                          <span>Tracks ({playlist.tracks.length})</span>
                        </h3>

                        <Container align="center" className="playlistPageMiddle">
                          <Row>
                            <Col md={{ span: 10, offset: 1 }} xs={12}>
                              {playlist.tracks.map((track) => (
                                <Link to={`/${track.id}`} className="playlistCard">
                                  <Card body className="m-3 text-left">
                                    <TrackImage width={`120px`} track={track} link={false} />
                                    <span className="trackArtist">
                                      "{track.title}" by {track.artist}
                                    </span>
                                    <div className="date"> Posted On: {dayjs(track.postedOn).format("MMMM D, YYYY")}</div>
                                  </Card>
                                </Link>
                              ))}
                            </Col>
                          </Row>
                        </Container>

                        {playlist.tracks && playlist.tracks.length === 0 && !isOwner && (<p>This playlist is a work in progress... Check back soon.</p>)}
                        {playlist.tracks && playlist.tracks.length === 0 && isOwner && (<p>There are currently no tracks in this playlist. Search the archives to add some.</p>)}

                      </div>
                      <Row>
                        <Col xs={12}>
                          <div className="createdDate">
                            Created: {new Date(playlist.datetime).toLocaleDateString()}
                            <br />
                            {playlist.tracks.length > 0 && (
                              <>Last Updated: {new Date(playlist.tracks[playlist.tracks.length - 1].datetime).toLocaleDateString()}</>
                            )}
                            <br />
                          </div>
                        </Col>
                      </Row>

                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 10, offset: 1 }} xs={12}>
                      {isOwner && (
                        <div className="ownerSearch">
                          <p>Find more tracks to add to your playlist</p>
                          <Button variant="secondary" size="md" onClick={() => handleGoToSearch()}>
                            Search
                          </Button>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 10, offset: 1 }} xs={12}>
                      {
                        <div className="explorePlaylists">
                          <p>Explore the recently added playlists</p>
                          <Button variant="secondary" size="md" onClick={() => handleGoToRecent()}>
                            Recent Playlists
                          </Button>
                        </div>
                      }
                    </Col>
                  </Row>
                  <Row className="divider"></Row>
                  {/* <GenreTracksContainer filter={match.params.genreId} render={(items) => items} /> */}
                  <Kba />
                </>
              )}
            </React.Fragment>
          );
        }}
      />
      {/* <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          I will not close if you click outside me. Don not even try to press
          escape key.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default PlaylistPage;
